export default {
  key: "voucher",
  id: "id",
  export: ["excel"],
  excel: {
     //max_row: "50000" 
  },
  sort_fields: [
    "id",
    "memberId",
    "voucherExpireDate",
    "rsrId",
    "address",
    "status",
    "campaignName"
  ],
  filters: {
    id: {},
    memberId: {},
    voucherExpireDate: {type: "daterange"},
    rsrId: {},
    status: {},
    address: {},
    campaignName: {},
    // creUser: {},
    // creDttm: {type: "daterange"},
    // lupdDttm: {type: "daterange"},
    // deleteDttm: {type: "daterange"},
    // redeemDttm: {type: "daterange"},
  },
  fields: [
    { key: "id", width: 75 ,hidden:["create"],disabled:["edit"]},
    { key: "memberId",disabled:["edit"], width: "10%"},
    { key: "campaignName",disabled:["edit"], width: "10%"},
    { key: "voucherExpireDate", type: "date", width: 120},
    { key: "rsrId",hidden:["create"],disabled:["edit"], width: 120},
    { key: "address",hidden:["create"], width: "15%"},
    { key: "status",hidden:["create"],disabled:["edit"], width: 120},
    { key: "creUserName",hidden:["create"], width: 120},
    { key: "creDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { key: "lupdDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { key: "deleteDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { key: "redeemDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { type: "action-btn", width: 40 },

  ],
  structure: [
    ["id","memberId"],
    ["campaignName","voucherExpireDate"],
    ["rsrId","status"],
    ["creUser","creDttm"],
    ["lupdDttm","deleteDttm"],
    ["redeemDttm"]
  ],
  action: ["create","delete"],
  // action: ["create","edit","view","delete"],
  options: {},
  view: [
    ["id","memberId"],
    ["voucherExpireDate"],
    ["rsrId","status"],
    ["creUser","creDttm"],
    ["lupdDttm","deleteDttm"],
    ["redeemDttm"]
  ],
  extra_components: {
  },
  disabled_by_column:{
    list:[
      {key:"status", val:"Valid", type:"eq"}
    ]
  },
  extra_privillege_components: {
  },
  import: {
    url:"voucher/import",
    demo_url:"Voucher.xlsx",
    fields:[
      {key:"memberId", not_null:true, label:"Member Id"},
      {key:"voucherExpireDate", not_null:true, type:"date", label:"Expire Date (yyyy-mm-dd)"},
      {key:"campaignName", not_null:true, label:"Campaign"}
    ],
  }
}